module.exports = __webpack_public_path__ + "img/Sambhajirao.b99e5909.jpg";